var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29279 12.7069C8.10532 12.5193 8 12.265 8 11.9999C8 11.7347 8.10532 11.4804 8.29279 11.2929L13.9498 5.63585C14.042 5.54034 14.1524 5.46416 14.2744 5.41175C14.3964 5.35934 14.5276 5.33176 14.6604 5.3306C14.7932 5.32945 14.9248 5.35475 15.0477 5.40503C15.1706 5.45531 15.2823 5.52957 15.3762 5.62346C15.4701 5.71735 15.5443 5.829 15.5946 5.9519C15.6449 6.0748 15.6702 6.20648 15.669 6.33926C15.6679 6.47204 15.6403 6.60325 15.5879 6.72526C15.5355 6.84726 15.4593 6.95761 15.3638 7.04985L10.4138 11.9999L15.3638 16.9499C15.5459 17.1385 15.6467 17.3911 15.6445 17.6533C15.6422 17.9155 15.537 18.1663 15.3516 18.3517C15.1662 18.5371 14.9154 18.6423 14.6532 18.6445C14.391 18.6468 14.1384 18.546 13.9498 18.3639L8.29279 12.7069Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.216ee80ad98aa6646d5de084d0b30a95.svg";
export { ForwardRef as ReactComponent };